import { render, staticRenderFns } from "./card-designs-index-body.vue?vue&type=template&id=ca75b504&"
import script from "./card-designs-index-body.vue?vue&type=script&lang=js&"
export * from "./card-designs-index-body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports